import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import {
  ColorStyle,
  fills,
  TDSnapshot,
  TDToolType,
  Theme,
  ToolButton,
  useTldrawApp,
} from 'sn-wb-tldraw';
import { Utils } from 'sn-wb-tldraw-core';

// import { CircleIcon, SquareIcon, VercelLogoIcon } from '@radix-ui/react-icons';
import { CircleIcon } from '../Primitives/icons';
import { colors, strokes } from './ColorMenu';
import { stickyColors } from './NoteMenu';

const currentStyleSelector = (s: TDSnapshot) => s.appState.currentStyle;

const canvasLight = '#fafafa';

const canvasDark = '#343d45';

const statusSelector = (s: TDSnapshot) => s.appState.status;

enum Status {
  SpacePanning = 'spacePanning',
}

interface ColorSelectorProps {
  isSticky: boolean;
}

export const ColorSelector = React.memo(function ColorSelector({ isSticky }: ColorSelectorProps) {
  const app = useTldrawApp();

  const status = app.useStore(statusSelector);
  const currentStyle = app.useStore(currentStyleSelector);
  const [displayedStyle, setDisplayedStyle] = React.useState(currentStyle);

  return (
    <>
      {Object.keys(isSticky ? stickyColors : strokes.light).map((style: string, i) => (
        <div
          key={style}
          className="flex flex-row gap-2 justify-items-center transform  hover:scale-90 duration-75 ease-in-out scale-90 "
        >
          <div
            // kbd={(4 + i).toString()}

            onClick={() => app.style({ color: style as ColorStyle })}
          >
            <DropdownMenu.Item asChild>
              <div className="flex items-center gap-2 cursor-pointer justify-center">
                <CircleIcon fill={isSticky ? stickyColors[style] : colors[style]} stroke="white" />
              </div>
            </DropdownMenu.Item>
          </div>
        </div>
      ))}
    </>
  );
});
